import api from "../../../utils/api";

export const createCiRelation = async (payload) => {
  if (process.env.NODE_ENV === "development") console.log(payload);
  const res = await api.post("/ci_relations/", payload);
  return res.data;
};

export const readCiRelation = async (publicId) => {
  if (!publicId) throw new Error("Missing or invalid ID for CI relation");
  const res = await api.get(`/ci_relations/${publicId}`);
  return res.data;
};

export const readCiRelations = async (params) => {
  const res = await api.get("/ci_relations", { params });
  return res.data;
};

export const updateCiRelation = async (payload) => {
  if (process.env.NODE_ENV === "development") console.log(payload);
  if (!payload.public_id) throw new Error("Missing or invalid ID for CI relation");
  const res = await api.put(`/ci_relations/${payload.public_id}`, payload);
  return res.data;
};

export const deleteCiRelation = async (publicId) => {
  if (process.env.NODE_ENV === "development") console.log(publicId);
  if (!publicId) throw new Error("Invalid ID for CI relation!");
  return await api.delete(`/ci_relations/${publicId}`);
};
